export default {
    form: {
        de: 'German',
        en: 'English',
        save: {
            label: 'Save',
            tooltip: 'Save feedback intro text'
        },
        label: {
            de: 'Feedback intro text german',
            en: 'Feedback intro text english'
        },
        enabled: {
            active: 'Feedback active',
            inactive: 'Feedback inactive',
            tooltip: {
                globallyDisabled: 'The evaluations have been disabled at the level of the trend radar or panel',
                toggle: {
                    true: 'Request feedback disable',
                    false: 'Request feedback enable'
                }
            }
        },
        error: {
            feedbackIntro: {
                required: 'Please enter a feedback intro text',
                length: 'The feedback intro text must not be longer than {cnt} characters'
            }
        }
    }
}
